import { Injectable } from "@angular/core";
import { CitizenIntroductionSteps, CitizenIntroductionStore } from "./citizen-introduction.store";

@Injectable()
export class CitizenIntroductionService {
    constructor(private store: CitizenIntroductionStore) {}

    public setInitialStep(step: CitizenIntroductionSteps): void {
        this.store.update({ currentStep: step });
    }

    public setPreviousStep(): void {
        const { currentStep } = this.store.getValue();

        switch (currentStep) {
            case CitizenIntroductionSteps.Welcome:
                break;
            case CitizenIntroductionSteps.Visit: {
                return this.store.update({ currentStep: CitizenIntroductionSteps.Welcome });
            }
            case CitizenIntroductionSteps.Responsibility: {
                return this.store.update({ currentStep: CitizenIntroductionSteps.Visit });
            }
            case CitizenIntroductionSteps.SuppliersAndPayment: {
                return this.store.update({ currentStep: CitizenIntroductionSteps.Responsibility });
            }
        }
    }

    public setNextStep(): void {
        const { currentStep } = this.store.getValue();

        switch (currentStep) {
            case CitizenIntroductionSteps.Welcome: {
                return this.store.update({ currentStep: CitizenIntroductionSteps.Visit });
            }
            case CitizenIntroductionSteps.Visit:
                return this.store.update({ currentStep: CitizenIntroductionSteps.Responsibility });
            case CitizenIntroductionSteps.Responsibility: {
                return this.store.update({ currentStep: CitizenIntroductionSteps.SuppliersAndPayment });
            }
            case CitizenIntroductionSteps.SuppliersAndPayment:
                break;
        }
    }
}
